import { render } from "./AdminRequests.vue?vue&type=template&id=575a5282"
import script from "./AdminRequests.vue?vue&type=script&lang=js"
export * from "./AdminRequests.vue?vue&type=script&lang=js"

import "./AdminRequests.vue?vue&type=style&index=0&id=575a5282&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__